import { useContext, useEffect, useState } from 'react'
import { FiLogOut } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import { AppSpan, AppText, Circle, CustomContainer, FlexColumn, FlexRow, GridContainer, Icon, SideBarContainer, SideBarShadow } from "src/style"
import { sideBarData } from './sidebar-data'
import { SidebarMenu } from './sidebar-menu'
import { DecisionBox } from 'src/component'
import { Features } from 'src/model'
import LogouBtn from 'src/assets/svg/logout-btn-d2'


export const SidebarD2: React.FC = () => {
    const navigate = useNavigate()
    const {info: {institutionData, userType}, logout} = useContext(AppInfoContext)
    const {user: {userInfo: {profileInfo}, uploadedProfilePics}} = useContext(UserContext)
    const {visibility, showSideBar, decisionBox} = useContext(VisibilityContext)
    const [isHover, setIsHover] = useState(false)
    const [isMobile] = useState(window.matchMedia('(max-width: 770px)').matches)
    const [uploadedPics, setUploadedPics] = useState(uploadedProfilePics)
    const [isDecisionBox, setIsDecisionBox] = useState(false)

    useEffect(() => {
        if (uploadedProfilePics) setUploadedPics(uploadedProfilePics)
    }, [uploadedProfilePics])

    async function handleLogout () {
        await logout()
        navigate('/login')
    }

    return (
        <>
            <SideBarShadow 
                isSideBar={visibility.isSideBar} 
                onClick={() => showSideBar(false)}
            />
            <SideBarContainer 
                isSideBar={visibility.isSideBar}
                width='25.5'
                zIndex='4'
                shadow='none'
                left='-30'
            >
                <FlexColumn 
                    minHeight='100' 
                    mnHUnit='%' 
                    justifyContent='space-between'
                    className='y-scrollable-container' 
                >
                    <CustomContainer 
                        bottomMargin='3' 
                        topMargin='8'
                    >
                        {
                            sideBarData.map((menu, index) => {
                                return (
                                    (
                                        (menu.title === 'Investment' && (!institutionData.featureIDs?.includes(Features.FIXED_DEPOSIT) && !institutionData.featureIDs?.includes(Features.TARGET_SAVINGS)))
                                        // || (menu.title === 'Borrow' && !institutionData.featureIDs?.includes(Features.RECOVA_LOAN))
                                    ) ?
                                        null
                                        : <SidebarMenu item={menu} key={index} />
                                )
                            })
                        }
                    </CustomContainer>
                    <FlexRow 
                        justifyContent='space-between' gap='2'
                        topMargin='2' topPadding='1'
                        style={{borderTop: '1px solid #EAECF0'}}
                    >
                        <FlexRow width='auto' sizeUnit='' gap='1'>
                            <Circle 
                                size='3.5' 
                                radius='20'
                                bgColor='#0D968F'
                                className='header-profile-pics' 
                                overflow='hidden'
                            >
                                { (!profileInfo?.profilePictureUrl && !uploadedPics) ?
                                    <AppText textSize='2.5' fontWeight='600' color='#ffffff' cursor='pointer'>
                                        {profileInfo?.firstName && profileInfo?.firstName[0]}
                                    </AppText>
                                    :
                                    <Icon src={uploadedPics || profileInfo.profilePictureUrl} minWidth='100' noResize style={{objectFit: 'cover'}} />
                                }
                            </Circle>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppSpan color='#58595B' fontWeight='700'>{profileInfo?.firstName} {profileInfo?.lastName}</AppSpan>
                                <AppText color='#A098AE'>User</AppText>
                            </CustomContainer>
                        </FlexRow>
                        <LogouBtn 
                            className='icon-component' 
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            isHover={isHover}
                            onClick={() => setIsDecisionBox(true)}
                        />
                    </FlexRow>
                </FlexColumn>
            </SideBarContainer>
            { isDecisionBox &&
                <DecisionBox 
                    yesBtnText='Yes, Logout'
                    noBtnTxt='No'
                    message='Are you sure you want to log out?'
                    height='22.5'
                    yesMethod={handleLogout}
                    close={() => setIsDecisionBox(false)} 
                />
            }
        </>
    )
}